<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  title: { type: String, required: true },
  description: { type: String, required: true },
  withBorder: { type: Boolean, default: false },
  hideContent: { type: Boolean, default: false },
  beta: { type: Boolean, default: false },
});
const { t } = useI18n();
</script>

<template>
  <section
    class="grid grid-cols-1 gap-5 py-6 [interpolate-size:allow-keywords]"
    :class="{
      'border-t border-auth-border dark:border-auth-border-dark': withBorder,
      'pb-6': !hideContent,
    }"
  >
    <header class="grid grid-cols-1 gap-3 sm:grid-cols-4">
      <div
        v-if="
          title || beta || $slots.title || description || $slots.description
        "
        class="sm:col-span-3"
      >
        <h4
          v-if="title || beta || $slots.title"
          class="flex items-center gap-2 text-heading-2 text-auth-text dark:text-auth-text-dark"
        >
          <slot name="title">{{ title }}</slot>
          <div
            v-if="beta"
            v-tooltip.top="t('GENERAL.BETA_DESCRIPTION')"
            class="text-xs uppercase text-n-iris-11 border border-1 border-n-iris-10 leading-none rounded-lg px-1 py-0.5"
          >
            {{ t('GENERAL.BETA') }}
          </div>
        </h4>
        <p
          v-if="description || $slots.description"
          class="mt-2 max-w-[65ch] text-body-main text-auth-muted dark:text-auth-muted-dark"
        >
          <slot name="description">{{ description }}</slot>
        </p>
      </div>
      <div class="sm:col-span-1">
        <slot name="headerActions" />
      </div>
    </header>
    <div
      class="text-auth-text transition-[height] duration-300 ease-in-out dark:text-auth-text-dark"
      :class="{ 'overflow-hidden h-0': hideContent, 'h-auto': !hideContent }"
    >
      <slot />
    </div>
  </section>
</template>
